import axios from 'axios'

export const getStationsConfigurations = async (filters) => {
  const res = (await axios.get(`/stations-configurations`, { params: filters })).data
  return res
}

export const getStationConfigurationLocals = async (stationId) => {
  const res = (await axios.get(`/stations-configurations/${stationId}/locals`)).data
  return res;
}